import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from './ui/badge';
import { MapPin, ArrowRight } from 'lucide-react';
import { DEPARTEMENTS } from '../data/departements';

const ZonesIntervention = () => (
  <section id="zones" className="py-20 bg-gray-50 scroll-mt-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <Badge className="mb-4 bg-green-100 text-green-700 hover:bg-green-100">Zones d'intervention</Badge>
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Location de benne <span className="text-green-600">partout en Ile-de-France</span>
        </h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Paris et les 7 départements de la petite et grande couronne, livraison sous 24h.
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="zones-grid">
        {DEPARTEMENTS.map((d) => (
          <Link
            key={d.code}
            to={d.path}
            className="group relative p-5 rounded-xl border-2 border-gray-100 hover:border-green-500 hover:shadow-lg transition-all bg-white"
            data-testid={`zone-link-${d.code}`}
          >
            <div className="flex items-center justify-between mb-3">
              <span className="text-3xl font-black text-green-600">{d.code}</span>
              <MapPin className="h-5 w-5 text-gray-300 group-hover:text-green-600 transition-colors" />
            </div>
            <p className="font-bold text-gray-900">{d.nom}</p>
            <p className="text-xs text-gray-500 mt-1 line-clamp-1">{d.villes.slice(0, 3).join(', ')}</p>
            <span className="mt-3 inline-flex items-center text-sm font-semibold text-green-700">
              Voir les tarifs <ArrowRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default ZonesIntervention;
